export { default } from "./MenuProduct";
